module.exports = __webpack_public_path__ + "img/2.9b1f4cdd.jpg";